// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InsightItem
 */
export interface InsightItem {
    /**
     * The insight content/message text
     * @type {string}
     * @memberof InsightItem
     */
    content: string;
    /**
     * File name this insight was generated from
     * @type {string}
     * @memberof InsightItem
     */
    fileName: string;
    /**
     * Unique identifier for the insight
     * @type {string}
     * @memberof InsightItem
     */
    insightId: string;
    /**
     * Study this insight belongs to
     * @type {string}
     * @memberof InsightItem
     */
    studyId: string;
    /**
     * ISO-8601 formatted timestamp for programmatic use
     * @type {Date}
     * @memberof InsightItem
     */
    timestamp: Date;
}

/**
 * Check if a given object implements the InsightItem interface.
 */
export function instanceOfInsightItem(value: object): value is InsightItem {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('insightId' in value) || value['insightId'] === undefined) return false;
    if (!('studyId' in value) || value['studyId'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    return true;
}

export function InsightItemFromJSON(json: any): InsightItem {
    return InsightItemFromJSONTyped(json, false);
}

export function InsightItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): InsightItem {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
        'fileName': json['fileName'],
        'insightId': json['insightId'],
        'studyId': json['studyId'],
        'timestamp': (new Date(json['timestamp'])),
    };
}

export function InsightItemToJSON(json: any): InsightItem {
    return InsightItemToJSONTyped(json, false);
}

export function InsightItemToJSONTyped(value?: InsightItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
        'fileName': value['fileName'],
        'insightId': value['insightId'],
        'studyId': value['studyId'],
        'timestamp': ((value['timestamp']).toISOString()),
    };
}
